'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var IoIosTimer = function IoIosTimer(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm19.8 3.8c8.9 0 16.2 7.2 16.2 16.2s-7.3 16.3-16.2 16.3-16.3-7.3-16.3-16.3 7.3-16.2 16.3-16.2z m-8.3 7.9c-0.2 0.2 6.7 9.4 6.7 9.4l0.1 0.1c0.4 0.4 0.8 0.8 1.5 0.8 1 0 1.9-0.9 1.9-2 0-0.5-0.2-1-0.6-1.4l-0.3-0.2s-9.1-6.8-9.3-6.7z m8.3 23.2c8.2 0 15-6.6 15-14.9s-6.8-15-15-15v7.5h1.2v-6.1c6.9 0.7 12.3 6.6 12.3 13.6 0 7.5-6 13.6-13.5 13.6s-13.7-6.1-13.7-13.6c0-3.7 1.5-7.2 4-9.7l-0.9-0.9c-2.7 2.7-4.4 6.5-4.4 10.6 0 8.3 6.7 14.9 15 14.9z' })
        )
    );
};

exports.default = IoIosTimer;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/io/ios-timer.js
// module id = 2305
// module chunks = 0